import styled from "styled-components";
import { theme } from "../theme";

export const StyledNavMenu = styled.div`
	height: 100%;
	display: flex;
	justify-content: flex-end;
	column-gap: 2.4rem;
	align-items: center;
	position: relative;

	button {
		display: flex;
		border: none;
		background: none;
		cursor: pointer;
	}

	a:last-of-type {
		height: calc(100% + 1.6rem);
		display: flex;
		align-items: center;
		column-gap: 2rem;

		position: relative;

		& > span {
			color: ${theme.color.black};
			font-size: 1.2rem;
			font-weight: 500;
			white-space: nowrap;
			line-height: 1.2rem;
		}
	}

	.dropdown {
		width: calc(100% + 10rem);
		padding: 1.5rem;

		display: none;
		align-items: center;
		column-gap: 1rem;

		position: absolute;
		bottom: 0;
		right: 0;

		transform: translate(7rem, calc(100% + 0.8rem));
		background-color: white;

		box-shadow: 0 0.5rem 0.6rem rgba(0, 0, 0, 0.16);

		cursor: pointer;
		/* pointer-events: none; */
	}

	&:hover .dropdown {
		display: flex;
	}
`;
